// Modules:
import React from 'react';

// Components:
import AgeGroupSelector from './SelectorTypes/AgeGroupSelector';
import CountySelector from './SelectorTypes/CountySelector';
import PeriodSelector from './SelectorTypes/PeriodSelector';

// Determines which selector to show based on the current topic and chart settings
const Selector = ({
    currentTab,
    stratification,
    ageGroups,
    handleAgeGroupSelect,
    processedCounties,
    handleDropdownSelect,
    styles,
    selection,
    chartDataYears,
    helperText,
}) => {
    if (currentTab.chartSettings.periodSelectable) {
        return (
            <PeriodSelector
                chartDataYears={chartDataYears}
                handleDropdownSelect={handleDropdownSelect}
                selection={selection}
                styles={styles}
                helperText={helperText || 'Select Period'}
            />
        );
    }

    if (currentTab.chartSettings.ageSelectable && stratification === 'age') {
        const allAgeGroups = currentTab.chartSettings.chartConfigs
            .filter((column) => column.stratification === 'age')
            .map(({ setName, label }) => ({ setName, label }));

        return (
            <AgeGroupSelector
                ageGroups={ageGroups}
                allAgeGroups={allAgeGroups}
                handleAgeGroupSelect={handleAgeGroupSelect}
            />
        );
    }

    if (currentTab.chartSettings.countySelectable) {
        return (
            <CountySelector
                currentTab={currentTab}
                counties={processedCounties}
                handleDropdownSelect={handleDropdownSelect}
                selection={selection}
                styles={styles}
            />
        );
    }

    return null;
};

export default Selector;
